<template>
  <Index />
</template>
<script route="/blogger/resourcelibrary/detail_cj">
  import Index from '@/views/blogger/resourcelibrary/components/Detail.jsx'
  export default {
    components: {Index}
  }
</script>